// Chakra imports
import { Box, 
    Text, 
    useColorModeValue,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuItemOption,
    MenuGroup,
    MenuOptionGroup,
    MenuIcon,
    MenuCommand,
    MenuDivider, 
    Button, 
    Input,
    Icon,
    Flex,
} from "@chakra-ui/react";
import { ChevronDownIcon } from '@chakra-ui/icons'
// Custom components
import Card from "components/card/Card.js";
import React from "react";
import { Grid, GridItem } from "@chakra-ui/react";
import { MdUpload } from "react-icons/md";

export default function Oneform(){
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const brandColor = useColorModeValue("brand.500", "white");
  const bg = useColorModeValue("white", "navy.700");
  return (
      <><Box max-width={"40%"}>
          <Menu>
              <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
                  Choose
              </MenuButton>
              <MenuList>
                  <MenuItem>Company Profile</MenuItem>
                  <MenuItem>Product - Apple Gala</MenuItem>
                  <MenuItem>Product - Bell Pepper Green</MenuItem>
                  <MenuItem>Product - Cucumber Long</MenuItem>
                  <MenuItem>+ Add New</MenuItem>
              </MenuList>
          </Menu>
      </Box>


<Box bg={bg} d="flex" alignItems="baseline">
      <Grid
  h="1000px"
  w="100%"
  templateRows="repeat(8, 1fr)"
  templateColumns="repeat(5, 1fr)"
  gap={"5%"}
>   
      <GridItem rowSpan={5} colSpan={1} > Company Profile</GridItem>
              <GridItem colSpan={4} w="80%" > <Input placeholder="Appelation" borderRadius="16px" /></GridItem>
              <GridItem colSpan={4} w="80%" > <Input placeholder="Street Name" borderRadius="16px" /></GridItem>
              <GridItem colSpan={4} w="80%" > <Input placeholder="City" borderRadius="16px" /></GridItem>
              <GridItem colSpan={4} w="80%" > <Input placeholder="Postal Code" borderRadius="16px" /></GridItem>
              <GridItem colSpan={4} w="80%" > <Input placeholder="Country" borderRadius="16px" /></GridItem>
       <GridItem colSpan={1} > Contact Details </GridItem>
              <GridItem colSpan={1} > <Input placeholder="Position" borderRadius="16px" /></GridItem>
              <GridItem colSpan={1} > <Input placeholder="Name" borderRadius="16px" /></GridItem>
              <GridItem colSpan={2} w="60%" > <Input placeholder="Email" borderRadius="16px" /></GridItem>
      <GridItem colSpan={1} >  Certificates </GridItem>
      <GridItem colSpan={3} >   <Box>
              <Icon as={MdUpload} max-w='20px' max-h='20px' color={brandColor} />
              <Flex justify='center' mx='auto' mb='12px'>
                <Text fontSize='sm' fontWeight='700' color={brandColor}>
                  Upload Files
                </Text>
              </Flex>
            </Box> </GridItem>
    <GridItem colSpan={1} >  </GridItem>
    <GridItem rowSpan={4} colSpan={1} > Product </GridItem>
      <GridItem colSpan={4} w="80%" > <Input placeholder="Prod. ID" borderRadius="16px" /></GridItem>
      <GridItem colSpan={4} w="80%" > <Input placeholder="Legal Name" borderRadius="16px" /></GridItem>
      <GridItem colSpan={4} w="80%" > <Input placeholder="Product Group" borderRadius="16px" /></GridItem>
      <GridItem colSpan={4} w="80%" > <Input placeholder="Contact Person(s)" borderRadius="16px" /></GridItem>
    <GridItem rowSpan={5} colSpan={1} > Product Details </GridItem>
      <GridItem colSpan={4} w="80%" > <Input placeholder="Outline of Ingredients" borderRadius="16px" /></GridItem>
      <GridItem colSpan={4} w="80%" > <Input placeholder="Nutritional Values" borderRadius="16px" /></GridItem>
      <GridItem colSpan={4} w="80%" > <Input placeholder="Allergens and Intolerances" borderRadius="16px" /></GridItem>
      <GridItem colSpan={4} w="80%" > <Input placeholder="Requirements" borderRadius="16px" /></GridItem>
      <GridItem colSpan={4} w="80%" > <Input placeholder="Requirements" borderRadius="16px" /></GridItem>
    <GridItem colSpan={1} > Lable / Packaging </GridItem>
      <GridItem colSpan={3} >   <Box>
              <Icon as={MdUpload} max-w='20px' max-h='20px' color={brandColor} />
              <Flex justify='center' mx='auto' mb='12px'>
                <Text fontSize='sm' fontWeight='700' color={brandColor}>
                  Upload Files
                </Text>
              </Flex>
            </Box> </GridItem>
  </Grid>
 </Box>
         </>
  );
}
